import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Text } from '@vds/core';
import { Button } from "@vds/buttons";
import { MarginTopSpacerM } from "common/components/styleTag";

const IncompatiblePackageModal = ({ opened, onOpenedChange, onContinue,sessionCartData,addToCartPayload, ...props }) => {
  const { t } = useTranslation(["app"]);
  const vbcInCart = sessionCartData?.cart?.packages !== null && sessionCartData?.cart?.packages !== undefined && Object.values(sessionCartData?.cart?.packages).filter( packageData => packageData?.packageType == "RENTAL_REGULAR").length > 0;
  const vbcToCart = addToCartPayload !== "" && addToCartPayload?.lines[0]?.packageType == "RENTAL_REGULAR";
  return (
    <>
      <StyledModal opened={opened} onOpenedChange={onOpenedChange} disableFocusLock= {true}>
      {vbcInCart ? <ModalTitle> {t("app.common.cartIncompatibleModalDAAS.heading")}</ModalTitle> : 
      vbcToCart ? <ModalTitle> {t("app.common.cartIncompatibleModalAddDAAS.heading")}</ModalTitle>
     : <ModalTitle>{t("app.common.cartIncompatibleModal.heading")}</ModalTitle>}
        <ModalBody>
          <ModalBodyContent>
           {(!vbcInCart && !vbcToCart) && <Text kind="body" size="large"><span dangerouslySetInnerHTML={{ __html: `${t("app.common.cartIncompatibleModal.description1a")} ${t(
              "app.common.cartIncompatibleModal.description1b"
            )}` }} /></Text>}
           {vbcInCart ? <Text kind="body" size="large">{t("app.common.cartIncompatibleModalDAAS.description2")}</Text> :
           vbcToCart ? <Text kind="body" size="large">{t("app.common.cartIncompatibleModalAddDAAS.description2")}</Text> :
            <Text kind="body" size="large">{t("app.common.cartIncompatibleModal.description2")}</Text>}
          </ModalBodyContent>
        </ModalBody>
        {vbcInCart ?    <StyledFooterContainer>
            <Button
              width="100%"
              onClick={() => {
                onContinue();
              }}
            >
              {t("app.common.cartIncompatibleModalDAAS.continue")}
            </Button>
            <MarginTopSpacerM />
            <Button
              width="100%"
              use="secondary"
              onClick={() => {
                onOpenedChange(false)
              }}
            >
              {t("app.common.cartIncompatibleModalDAAS.cancel")}
            </Button>

          </StyledFooterContainer>
        :
        vbcToCart ? 
        <StyledFooterContainer>
            <Button
              width="100%"
              onClick={() => {
                onContinue();
              }}
            >
              {t("app.common.cartIncompatibleModalAddDAAS.continue")}
            </Button>
            <MarginTopSpacerM />
            <Button
              width="100%"
              use="secondary"
              onClick={() => {
                onOpenedChange(false)
              }}
            >
              {t("app.common.cartIncompatibleModalAddDAAS.cancel")}
            </Button>

          </StyledFooterContainer>
        :
        <ModalFooter
          buttonData={{
            primary: {
              children: t("app.common.cartIncompatibleModal.continue"),
              onClick: () => onContinue()
            },
            close: {
              children: t("app.common.cartIncompatibleModal.cancel"),
              onClick: () => onOpenedChange(false)
            }
          }}
        /> }
      </StyledModal>
    </>
  );
};

const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  a {
    color: black;
  }
`;

const StyledModal = styled(Modal)`
  @media only screen and (min-width: 768px) {

  [class^=StyledHeader-VDS]{
    padding-right: 0px !important;
}}`

export const StyledFooterContainer = styled.div`
    padding-top: 30px !important;
`
    

export default IncompatiblePackageModal;
